import { useNavigate } from "react-router-dom";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import { ContractAPI } from "../../Api/ContractAPI";
import AfinAPI from "../../Api/AfinAPI";

import { useCreateSignature } from "../../Hooks/useCreateSignature/useCreateSignature";

import { ICreateSignature } from "./ICreateSignature";

export interface recipients {
	email: string;
	name: string;
	type: string;
	require_file_attachment: number;
};

const CreateSignature = ({
	baseURL,
	baseURLExternal,
	translations,
	clientId,
	isInvestor,
	moduleRole,
	userIdInstitution
}: ICreateSignature) => {
	const navigate = useNavigate();

	const {
		loading,
		getContent,
	} = useCreateSignature({
		translations,
		contractAPI: ContractAPI(baseURL, baseURLExternal, clientId),
		afinAPI:  AfinAPI(baseURL, clientId),
		navigate,
		isInvestor,
		userIdInstitution,
		moduleRole
	});

	return (
		<div className="data-wrapper">
			<Spin
				spinning={loading}
				indicator={
					<LoadingOutlined style={{ fontSize: 34, color: "black" }} spin />
				}
			>
				{ getContent() }
			</Spin>
		</div>
	);
};

export default CreateSignature;
